import { Paper } from "@mui/material";

const PaperComponent = ({
  children,
  paperStyle,
  disabled = false,
  noDrop,
  ...props
}) => {
  return (
    <Paper
      elevation={noDrop ? 0 : 4}
      sx={{
        my: 2,
        py: { xs: 1.5, sm: 2 },
        px: { xs: 1.5, sm: 3 },
        borderRadius: { xs: "8px", md: "20px" },
        opacity: !disabled ? 1 : 0.2,
        ...paperStyle,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

export default PaperComponent;
